<tt-page *ngIf="!!get">
    <tt-page-heading ttModel="p2_m_interbranchequipmentinvoicing" ttTranslate></tt-page-heading>

    <div class="interbranchequipmentinvoicing__head">
        <tt-card class="col-xs-12 col-md-3 sp-0">
            <tt-select
                ttRememberId="w_interbranchequipmentinvoicing.businessco_no"
                ttLabel="businessco_no"
                [(ttModel)]="get.businessco_no"
                (ttModelChange)="readGrid()"
                [ttData]="companies"
                ttDataId="businessco_no"
                ttDataName="company_name"
            ></tt-select>
            <tt-select
                ttRememberId="w_interbranchequipmentinvoicing.businessco_equipment"
                ttLabel="businessco_equipment"
                [(ttModel)]="get.businessco_equipment"
                (ttModelChange)="readGrid()"
                [ttData]="companies"
                ttDataId="businessco_no"
                ttDataName="company_name"
            ></tt-select>
            <tt-search
                ttLabel="project_name"
                [(ttModel)]="get.project_name"
                [ttSearch]="searchProjects"
                (ttOnSelected)="projectSelected($event); readGrid()"
                (ttOnClear)="projectSelected(); readGrid()"
            ></tt-search>
        </tt-card>
        <tt-card class="col-xs-12 col-md-3 sp-0">
            <tt-date-range
                [hidden]="get.selected_tab === 'show'"
                ttRememberId="w_interbranchequipmentinvoicing"
                ttLabel="date_fom_tom"
                [(ttStartDate)]="get.date_fom"
                [(ttEndDate)]="get.date_tom"
                [(ttInterval)]="get.dateselector_index"
                (ttModelChange)="readGrid()"
            ></tt-date-range>
            <tt-checkbox
                [hidden]="get.selected_tab === 'show'"
                ttRememberId="w_interbranchequipmentinvoicing.show_invoiced"
                ttLabel="show_invoiced"
                [(ttModel)]="get.show_invoiced"
                (ttModelChange)="readGrid()"
            ></tt-checkbox>
            <tt-date
                [hidden]="get.selected_tab === 'select'"
                ttRememberId="w_interbranchequipmentinvoicing.invoice_date"
                ttLabel="invoice_date"
                [(ttModel)]="get.invoice_date"
                (ttModelChange)="readGrid()"
            ></tt-date>
        </tt-card>
    </div>

    <tt-tabs ttRememberId="w_interbranchequipmentinvoicing.selected_tab" [ttOnlyRemember]="true" [(ttSelectedId)]="get.selected_tab" (ttSelectedIdChange)="readGrid()">
        <tt-tab ttId="select" ttLabel="interbranchequimentinvoicing_select"></tt-tab>
        <tt-tab ttId="show" ttLabel="interbranchequimentinvoicing_show"></tt-tab>
    </tt-tabs>

    <div class="interbranchequipmentinvoicing__grid">
        <tt-grid *ngIf="!!selectGrid" [hidden]="get.selected_tab !== 'select'" [(ttOptions)]="selectGrid"></tt-grid>
        <tt-grid *ngIf="!!showGrid" [hidden]="get.selected_tab !== 'show'" [(ttOptions)]="showGrid"></tt-grid>
    </div>
</tt-page>
